import { defineMessages } from 'react-intl';

export default defineMessages({
  myServices: {
    id: 'dashboard_amc.my_services',
  },
  findDoctor: {
    id: 'dashboard_amc.find_doctor',
  },
  findAgent: {
    id: 'dashboard_amc.find_agent',
  },
  practicalData: {
    id: 'dashboard_amc.practical.data',
  },
  procedure: {
    id: 'dashboard_amc.procedure',
  },
  guides: {
    id: 'dashboard_amc.guides',
  },
});
